export default __webpack_public_path__ + "static/media/bg-pattern-icons-2x.4ceeb208.png";